module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "d_modal",
    staticClass: "modal-wrapper",
    class: [{
      'no-print': !_vm.isPrintable
    }, {
      'modal-wrapper--printable': _vm.isPrintable
    }, {
      'js-no-close': _vm.appendToBody
    }, {
      'modal-wrapper--from-top': _vm.placeInTop
    }],
    style: (_vm.zIndex ? {
      zIndex: _vm.zIndex
    } : null),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    ref: "modalContent",
    staticClass: "modal",
    style: ({
      top: !_vm.placeInTop ? '0px' : _vm.pxFromTop + 'rem'
    }),
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.ariaLabel || null
    }
  }, [(_vm.showClose) ? _c('button', {
    staticClass: "close-cross",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('vue2.a11y.close')
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
    return [_c('h2', [_vm._v("Hello")])]
  })], 2), _vm._v(" "), (_vm.isBgOverlay) ? _c('div', {
    staticClass: "bg-overlay animateFast fadeIn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onBgClick.apply(null, arguments)
      }
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4549b0c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DModal.vue
// module id = 1891
// module chunks = 1